import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"i126079744__a\"><circle cx=\"256\" cy=\"256\" r=\"256\" fill=\"#fff\"></circle></mask><g mask=\"url(#i126079744__a)\"><path fill=\"#eee\" d=\"m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z\"></path><path fill=\"#a2001d\" d=\"M0 0h512v167H0z\"></path><path fill=\"#0052b4\" d=\"M0 345h512v167H0z\"></path></g>", 2)
  ])))
}
export default { render: render }